export default "__VITE_ASSET__BhLEisAH__"